import { create } from 'zustand'

import { TabOption } from '@/components/common/Tabs'

export type TabLabelKey = 'devan' | 'delivery'

interface ScheduleState {
  loading: boolean
  tabLabels: TabOption[]
  activeTab: TabLabelKey
}

interface ScheduleActions {
  changeTabLabel: (tabKey: TabLabelKey) => void
}

type ScheduleStore = ScheduleState & ScheduleActions

const initialState: ScheduleState = {
  loading: false,
  tabLabels: [
    { value: 'devan', label: '预约拆柜' },
    { value: 'delivery', label: '预约搬出' },
  ],
  activeTab: 'devan'
}

export const useScheduleStore = create<ScheduleStore>()((set) => ({
  ...initialState,
  changeTabLabel: (value) => {
    set({
      activeTab: value
    })
  }
}))

export const useScheduleState = () => {
  const tabLabels = useScheduleStore((state) => state.tabLabels)
  const activeTab = useScheduleStore((state) => state.activeTab)
  return { tabLabels, activeTab }
}

export const useScheduleActions = () => {
  const changeTabLabel = useScheduleStore((state) => state.changeTabLabel)
  return { changeTabLabel }
}
